// extracted by mini-css-extract-plugin
export var formErrorBanner = "errorBanner_formErrorBanner__jBcSS";